<template>
  <el-dialog
    title="錄音流通匯入"
    fullscreen
    @close="handleDlgClose"
    :visible.sync="innerVisible"
  >
    <div class="container" v-loading="isLoading">
      <div class="row justify-content-between">
        <div class="px-2">
          <el-upload
            v-loading="loading"
            ref="upload"
            action=""
            accept="application/vnd.openxmlformats-officedocument.spreadsheetml.sheet, application/vnd.ms-excel"
            :on-change="handleChange"
            :on-exceed="handleExceed"
            :multiple="false"
            :limit="1"
            :auto-upload="false"
            :show-file-list="false"
          >
            <el-button size="small" type="primary" @click="selectFileClicked"
              >選擇Excel文件</el-button
            >
            <div slot="tip" class="el-upload__tip">限xlsx檔</div>
          </el-upload>
        </div>
        <div class="funcpanel">
          <el-button
            type="primary"
            @click="uploadRows"
            size="small"
            :disabled="!isDataUploadable"
            >上傳資料</el-button
          >
          <el-button type="primary" @click="downloadSample" size="small"
            >下載範例檔案</el-button
          >
        </div>
      </div>
    </div>

    <el-alert v-if="fileData.length" :type="alertStatus" :closable="false" class="my-1">
      資料筆數：待上傳({{ totalReady }}); 上傳成功({{ totalSuccess }}); 錯誤({{ totalError }})
    </el-alert>
    <CCard>
      <CCardHeader>
        <CIcon name="cil-library-building" /> 單位：{{ myownOrg }}
      </CCardHeader>
      <CCardBody>
        <CRow>
          <el-table
          :border="true"
            :cell-style="cellStyle"
            :data="fileData.slice((currentPage-1)*pageSize,currentPage*pageSize)"
            style="width: 100%"
            :default-sort="{ prop: defaultSortCol, order: defaultOrder }"
            @sort-change="sortChange"
            stripe
          >
            <el-table-column prop="rowNo" label="#" width="70" sortable>
            </el-table-column>

            <el-table-column prop="state" label="狀態" width="80" sortable>
              <template #default="scope">
                <div v-loading="scope.row.isUploading">
                <img
                  v-if="isGreenLight(scope.row)"
                  src="../../assets/icons/success.svg"
                  class="successicon"
                />
                <img
                  v-if="isRedLight(scope.row)"
                  src="../../assets/icons/failure.svg"
                  class="stateicon"
                />
                </div>
              </template>
            </el-table-column>
            <el-table-column prop="msg" label="訊息" width="120" sortable>
            </el-table-column>
            <el-table-column prop="recshareName" label="錄音流通名稱" width="200" sortable>
              <template #default="scope">
                {{ scope.row.recshareName ? scope.row.recshareName : "(未指定)" }}
              </template>
            </el-table-column>
            <el-table-column prop="admins" label="管理員" width="300" sortable></el-table-column>
            <el-table-column prop="members" label="成員" width="300" sortable>
            </el-table-column>
            <el-table-column
              prop="isUpload"
              label="允許上傳檔案"
              width="200"
              sortable
            >
            </el-table-column>
          </el-table>
    
        </CRow>
        <CRow>
                <el-pagination
            :current-page.sync="currentPage"
            :page-sizes="[50, 100, 150, 200]"
            :page-size="pageSize"
            layout="total, sizes, prev, pager, next, jumper"
            :total="fileData.length">
        </el-pagination>
        </CRow>
      </CCardBody>
    </CCard>
  </el-dialog>
</template>

<script>
import XLSX from "xlsx";
import appConfig from "../../appConfig";
import { mapGetters } from "vuex";
import API from "../../api";
//import moment from "moment-timezone";
//import Vue from "vue";
//Vue.filter("converDate", function(value) {
//if (value) {
//const tz = Intl.DateTimeFormat().resolvedOptions().timeZone;
//return moment(value)
//.tz(tz)
//.format("YYYY-MM-DD");
//} else {
//return value;
//}
//});
export default {
  props: {
    visible: {
      type: Boolean,
      default: false,
    },
  },
  model: {
    prop: "visible",
    event: "toggleVisible",
  },
  data() {
    return {
      hasUploaded: false,
      defaultSortCol: "rowNo",
      defaultOrder: "ascending",
      isLoading: false,
      departments: [],
      deptNames: [],
      deptIds: [],
      loading: false,
      fileData: [],
      currentPage: 1,
      pageSize: 50,
    };
  },
  created() {
  },
  computed: {
    innerVisible: {
      get() {
        return this.visible;
      },
      set(val) {
        this.$emit("toggleVisible", val);
      },
    },
    alertStatus() {
      if (this.totalError) {
        return "error";
      }
      else if (this.totalReady) {
        return "info";
      }
      else {
        return "success";
      }
    },
    totalSuccess() {
      return this.fileData.reduce(((acc, item) => item.state === appConfig.IMPORT_XLSX.STATE.SUCCEED ? acc + 1 : acc), 0)
    },
    totalReady() {
      return this.fileData.reduce(((acc, item) => item.state === appConfig.IMPORT_XLSX.STATE.READY ? acc + 1 : acc), 0)
    },
    totalError() {
      return this.fileData.reduce(((acc, item) => (item.state === appConfig.IMPORT_XLSX.STATE.INCORRECT) ||(item.state === appConfig.IMPORT_XLSX.STATE.FAIL)  ? acc + 1 : acc), 0)
    },
    isDataUploadable() {
      return this.fileData.some(
        item => item.state === appConfig.IMPORT_XLSX.STATE.READY
      );
    },
    ...mapGetters({
      myownOrg: "auth/orgName",
    }),
  },
  methods: {
    downloadSample() {
      const a = document.createElement("a");
      a.href = "/錄音流通匯入.xlsx";
      a.download = "錄音流通匯入.xlsx";
      document.body.appendChild(a);
      a.click();
      document.body.removeChild(a);
    },
    selectFileClicked() {
      this.$refs.upload.clearFiles();
    },
    isGreenLight(row) {
      return row.state === appConfig.IMPORT_XLSX.STATE.SUCCEED;
    },
    isRedLight(row) {
      return (
        row.state === appConfig.IMPORT_XLSX.STATE.INCORRECT ||
        row.state === appConfig.IMPORT_XLSX.STATE.FAIL
      );
    },
    cellStyle(params) {
      //{row, column, rowIndex, columnIndex}
      if (params.column.property == "name") {
        if (
          params.row.state === appConfig.IMPORT_XLSX.STATE.INCORRECT &&
          !params.row.name
        ) {
          return "color:#F56C6C;";
        }
      } else if (params.column.property == "msg") {
        if (params.row.state === appConfig.IMPORT_XLSX.STATE.SUCCEED) {
          return "color:#67C23A;";
        } else if (
          params.row.state === appConfig.IMPORT_XLSX.STATE.INCORRECT ||
          params.row.state === appConfig.IMPORT_XLSX.STATE.FAIL
        ) {
          return "color:#F56C6C;";
        }
      } else {
        return "";
      }
    },

    uploadRows() {
      this.hasUploaded = true;
      this.isLoading = true;
      const allRows = Array.from(
        { length: appConfig.IMPORT_XLSX.UPLOAD_WORKERS },
        () => []
      );
      this.fileData.forEach((dataRow, idx) => {
        const workerIdx = idx % appConfig.IMPORT_XLSX.UPLOAD_WORKERS;
        allRows[workerIdx].push(dataRow);
      });

      const workerPrms = allRows.map(worker => {
        let p = Promise.resolve();
        worker.forEach(row => {
          p = p.then(() => this.uploadOneRow(row));
        });
        return p;
      });
      Promise.all(workerPrms).finally(() => {
        this.isLoading = false;
      });
    },

    uploadOneRow(dataRow) {
      if (dataRow.state !== appConfig.IMPORT_XLSX.STATE.READY) {
        return Promise.resolve(true);
      }
      //const { deptNames, msg, state, ...params } = dataRow;
      const {
        recshareName,
        admins,
        members,
        isUpload
      } = dataRow;
      const params = {
        recshareName,
        admins,
        members,
        isUpload
      };

      dataRow.isUploading = true;
      return API.recshare
        .batchAdd(params)
        .then(res => {
          if (res.status === 201) {
            dataRow.state = appConfig.IMPORT_XLSX.STATE.SUCCEED;
            dataRow.msg = appConfig.IMPORT_XLSX.MSG.UPLOADED;
            return true;
          } else {
            dataRow.state = appConfig.IMPORT_XLSX.STATE.FAIL;
            let errMsg = res?.data?.message;
            errMsg = errMsg || res?.message;
            dataRow.msg = errMsg;
            return false;
          }
        })
        .catch(err => {
          dataRow.state = appConfig.IMPORT_XLSX.STATE.FAIL;
          let errMsg = err?.response?.data?.message;
          errMsg = errMsg || err?.message;
          dataRow.msg = errMsg;
          return Promise.resolve(false);
        })
        .finally(() => {
          dataRow.isUploading = false; 
        })
    },


    handleChange(file) {
      this.fileData = [];
      this.total = 0;
      //wbreak
      const fileTemp = file.raw;
      if (fileTemp) {
        console.assert(
          fileTemp.type ==
            "application/vnd.openxmlformats-officedocument.spreadsheetml.sheet" ||
            fileTemp.type == "application/vnd.ms-excel"
        );
        this.importData(fileTemp);
      } else {
        this.$message({
          type: "warning",
          message: "選擇的檔案發生錯誤，請重新選擇!",
        });
      }
    },

    handleExceed() {
      this.$message({
        type: "warning",
        message: "超過上傳檔案數量限制!",
      });
    },

    importData(file) {
      const tableData = this.fileData;

      const reader = new FileReader();
      reader.onload = e => {
        const bytes = new Uint8Array(e.target.result);

        const wb = XLSX.read(bytes, { type: "array" });
        const outdata = XLSX.utils.sheet_to_json(wb.Sheets[wb.SheetNames[0]]);
        //console.log(`worksheet[0] = ${JSON.stringify(outdata)}`);

        //Data can be processed here.
        const label_recshare_name = "錄音流通名稱";
        const label_admin = "管理員";
        const label_member = "成員";
        const label_isUpload = "允許上傳檔案";

        outdata.forEach((v, idx) => {
          const obj = {};
          obj.state = appConfig.IMPORT_XLSX.STATE.READY;
          obj.recshareName = v[label_recshare_name] ? `${v[label_recshare_name]}`.trim() : "";
          obj.admins = v[label_admin]
            ? `${v[label_admin]}`.trim()
            : "";
          obj.members = v[label_member]
            ? `${v[label_member]}`.trim()
            : "";
          obj.isUpload = v[label_isUpload]
            ? `${v[label_isUpload]}`.trim()
            : "";
    
          obj.msg = "";


          obj.recshareName = v[label_recshare_name] ? `${v[label_recshare_name]}`.trim() : "";
          if (!obj.recshareName) {
            obj.msg = obj.msg
              ? `${obj.msg};${appConfig.IMPORT_XLSX.MSG.RECSHARE_NAME_ERR}`
              : appConfig.IMPORT_XLSX.MSG.RECSHARE_NAME_ERR;
            obj.state = appConfig.IMPORT_XLSX.STATE.INCORRECT;
            //obj.name = "(未指定)";
          }

          obj.msg = obj.msg ? obj.msg : appConfig.IMPORT_XLSX.MSG.TO_UPLOAD;

          obj.rowNo = idx + 1;
          obj.isUploading = false;

          tableData.push(obj);
        });
        this.isLoading = false;
      };
      this.isLoading = true;
      reader.readAsArrayBuffer(file);
    },

    sortChange(args) {
      console.log(`sortChange: prop = ${args.prop}, order = ${args.order}`);
      const sortData = (colName, order) => {
        this.fileData = this.fileData.sort((a, b) => {
          if (order === "ascending") {
            return a[colName] - b[colName];
          } else {
            return b[colName] - a[colName];
          }
        });
      };
      if (args.order === null) {
        sortData(this.defaultSortCol, this.defaultOrder);
      }
    },
    handleDlgClose() {
      if (this.hasUploaded) {
        this.$store.dispatch('recshare/list', null);
      }
    },
  },
};
</script>

<style scoped>
.dept-tag {
  margin-right: 3px;
  margin-bottom: 3px;
}
.successicon {
  width: 27px;
  height: 27px;
  margin-left: 2px;
  margin-right: 2px;
}
.stateicon {
  width: 24px;
  height: 24px;
  margin-left: 2px;
  margin-right: 2px;
}
</style>
